// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__oF2iF","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3KTUW"};